import React, {useState} from "react"
import '../Styles.css'
import './Discover.css'
import {Footer} from "../Footer";
import {useSendProviderInquiry} from "../../util/RpcHooks/SendProviderInquiryEmail";
import {ISendProviderInquiryRequest, SendProviderInquiryRequest, space} from "../../provider_api";
import {ActionButton} from "../../util/UI/ActionButton";
import {findError} from "../../components/input/InputTypes";
import {RpcState} from "../../util/RpcState";
import IErrorProto = space.kenko.proto.IErrorProto;


/**
 * This is at the root path. It shows a marketing page
 * for why Kensu is great for practitioners. This does not require authentication.
 */
export const Discover = () => {

  const sendProviderInquiry = useSendProviderInquiry()

  const [inquiry, setInquiry] = useState<ISendProviderInquiryRequest>(new SendProviderInquiryRequest());

  // 0: filling out form
  // 1: done
  const [step, setStep] = useState(0);

  if (step == 0) {
    return <>
      <div className="DiscoverPage">
        <div className={'AppSection BeigeSection'}>
          <div className={'AppSectionContent DiscoverPageSection'}>

            <h1>Thank you for your interest in Kensu.</h1>

            <p>We’d love to learn more about your practice and philosophy to see if we’re aligned in purpose and
              approach. Please take a moment to complete this short form.</p>
            
            <h3>1. Please provide some contact information so we can reach you:</h3>

            <InputField placeholder={'First name'}
                        fieldName={'firstName'}
                        rpc={sendProviderInquiry}
                        inquiry={inquiry}
                        setInquiry={setInquiry}/>

            <InputField placeholder={'Last name'}
                        fieldName={'lastName'}
                        rpc={sendProviderInquiry}
                        inquiry={inquiry}
                        setInquiry={setInquiry}/>

            <InputField placeholder={'Email address'}
                        fieldName={'email'}
                        inquiry={inquiry}
                        setInquiry={setInquiry}
                        rpc={sendProviderInquiry}/>

            <InputField placeholder={'Phone number'}
                        fieldName={'phone'}
                        inquiry={inquiry}
                        setInquiry={setInquiry}
                        rpc={sendProviderInquiry}/>

            <InputField placeholder={'Website (Optional)'}
                        fieldName={'website'}
                        inquiry={inquiry}
                        setInquiry={setInquiry}
                        rpc={sendProviderInquiry}/>

            <h3>2. What are your primary modalities or areas of practice?</h3>
            <TextAreaField placeholder={'E.g., acupuncture, nutrition, bodywork, etc.'}
                           fieldName={'primaryModalities'}
                           inquiry={inquiry}
                           setInquiry={setInquiry}
                           rpc={sendProviderInquiry}/>

            <h3>3. What licenses or certifications do you (or your team members) currently hold?</h3>
            <TextAreaField fieldName={'licensesCertifications'}
                           inquiry={inquiry}
                           setInquiry={setInquiry}
                           rpc={sendProviderInquiry}/>

            <h3>4. How many years have you been in practice?</h3>
            <InputField fieldName={'yearsInPractice'}
                        inquiry={inquiry}
                        setInquiry={setInquiry}
                        rpc={sendProviderInquiry}/>

            <h3>5. How would you describe your healing or treatment philosophy in a sentence or two?</h3>
            <TextAreaField fieldName={'healingPhilosophy'}
                           inquiry={inquiry}
                           setInquiry={setInquiry}
                           rpc={sendProviderInquiry}/>

            <h3>6. Who referred you to Kensu (if applicable)?</h3>
            <InputField fieldName={'whoReferredYou'}
                        inquiry={inquiry}
                        setInquiry={setInquiry}
                        rpc={sendProviderInquiry}/>

            <h3>7. Is there anything else you’d like us to know about your practice or goals?</h3>
            <TextAreaField fieldName={'anythingElse'}
                           inquiry={inquiry}
                           setInquiry={setInquiry}
                           rpc={sendProviderInquiry}/>


            <ActionButton
                disabled={sendProviderInquiry.rpcState.state == 'success'}
                rpcState={sendProviderInquiry.rpcState}
                onClick={() => sendProviderInquiry.send({request: inquiry, onSuccess: () => setStep(step + 1)})}
            >SUBMIT</ActionButton>

            {sendProviderInquiry.rpcState.state == 'success' &&
                <div>Your request has been submitted! The Kensu team will reach out to you within two business
                  days.</div>}

            {sendProviderInquiry.rpcState.state == 'error' && !sendProviderInquiry.errors.length &&
                <div className={'ErrorText'}>There was an error submitting your request. Please try again later.</div>}

          </div>
        </div>
        <Footer/>
      </div>
    </>
  }

  return <>
    <div className="DiscoverPage">
      <div className={'AppSection BeigeSection'}>
        <div className={'AppSectionContent DiscoverPageSection'}>
          <h1>Thank you for completing this form!</h1>
          <p>
            Our team will review your responses and be in touch soon. If we feel your practice aligns with Kensu’s
            network, we’ll reach out to schedule a discovery call. If not, we’ll still follow up to let you know our
            decision or suggest any next steps as applicable.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  </>
}


const InputField = (props: {
  placeholder?: string,
  fieldName: keyof ISendProviderInquiryRequest,
  inquiry: ISendProviderInquiryRequest,
  setInquiry: (inquiry: ISendProviderInquiryRequest) => void,
  rpc: { rpcState: RpcState, errors: IErrorProto[] },
}) => {
  return <>
    <input placeholder={props.placeholder} value={props.inquiry[props.fieldName] ?? ''}
           disabled={props.rpc.rpcState.state == 'pending'}
           onChange={e => props.setInquiry({...props.inquiry, [props.fieldName]: e.target.value})}/>
    <div className={'ErrorText'}>{findError(props.rpc.errors, props.fieldName)}</div>
  </>
}

const TextAreaField = (props: {
  placeholder?: string,
  fieldName: keyof ISendProviderInquiryRequest,
  inquiry: ISendProviderInquiryRequest,
  setInquiry: (inquiry: ISendProviderInquiryRequest) => void,
  rpc: { rpcState: RpcState, errors: IErrorProto[] },
}) => {
  return <>
    <textarea placeholder={props.placeholder} value={props.inquiry[props.fieldName] ?? ''}
              rows={4}
              disabled={props.rpc.rpcState.state == 'pending'}
              onChange={e => props.setInquiry({...props.inquiry, [props.fieldName]: e.target.value})}/>
    <div className={'ErrorText'}>{findError(props.rpc.errors, props.fieldName)}</div>
  </>
}